import { shouldForwardProp } from "@mui/system";
import { Box, Divider, IconButton, Select, styled } from "../../../base";

export const MetricsContainer = styled(Box)(({ theme }) => ({
    minHeight: '95px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 15,
}));

export const MetricItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
        transform: 'scale(1.05)',
    },
}));

export const IconCircle = styled(Box)(({ theme }) => ({
    width: 56,
    height: 56,
    flexShrink: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(0deg,${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    color: theme.palette.common.white,
    marginInlineEnd: theme.spacing(2),
}));

export const TextContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
});

export const StyledSelect = styled(Select)(({ theme }) => ({
    minWidth: 120,
    marginInlineEnd: theme.spacing(2),
    '&.MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: theme.palette.secondary.main,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.secondary.main,
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.secondary.main,
        },
    },
    '& .MuiSelect-select': {
        color: theme.palette.secondary.main,
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.secondary.main,
    },
}));

export const VerticalDivider = styled(Divider)(({ theme }) => ({
    height: '20px',
    margin: theme.spacing(0, 2),
    backgroundColor: theme.palette.grey[300],
}));

export const MetadataContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
}));

export const MetadataItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
});

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['borderColor', 'iconColor'].includes(prop as string);

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ borderColor: string }>(({ theme, borderColor }) => ({
    border: '2px solid',
    borderColor: borderColor,
    marginInlineEnd: theme.spacing(1),
    height: '46px',
    width: '46px',

    '&:hover': {
        backgroundColor: theme.palette.background.mainBackground, // Background color on hover
        borderColor: borderColor,
    },
}));